import React, { useEffect } from "react";
import Hero from "../components/Hero";
import AOS from "aos";
import SEO from "../components/SEO";

const slidesData = [
    {
        id: 1,
        image: "/assets/img/hero-2.jpg",
        title: "Online Classes",
        subtitle: "To access Online Classes, please follow the link below. The recordings and materials are hosted on our SharePoint site",
        showButton: true,
        buttonText: "Access Online Classes",
        buttonLink: "https://africaresearchuniversity404.sharepoint.com/sites/ARUOnlineClasses/Shared%20Documents/Forms/AllItems.aspx?id=%2Fsites%2FARUOnlineClasses%2FShared%20Documents%2FGeneral%2FRecordings&viewid=3f77e356%2D8fd7%2D4bb4%2D98a0%2D1cc53d5612bb",
    },
];

const OnlineClassesPage = () => {
    useEffect(() => {
        AOS.init({ duration: 800, once: true });
    }, []);

    // Scroll to top on mount
    useEffect(() => {
        try {
            if (typeof window !== 'undefined' && window?.scrollTo) {
                window.scrollTo({ top: 0, left: 0, behavior: 'auto' });
            }
        } catch (e) {
            try {
                window.scrollTo(0, 0);
            } catch (err) {
                // ignore
            }
        }
    }, []);

    const pageUrl = typeof window !== 'undefined' ? window.location.href : 'https://africaresearchuniversity.com/online-classes';
    const jsonLd = {
        '@context': 'https://schema.org',
        '@type': 'WebPage',
        'name': 'Online Classes - Africa Research University',
        'description': 'Access recordings and materials for ARU online classes.',
        'url': pageUrl
    };

    return (
        <section className="pt-1 pb-16">
            <SEO title="Online Classes — Africa Research University" description="Access recordings and materials for ARU online classes." image="/assets/img/arulogo.png" url={pageUrl} jsonLd={jsonLd} />

            <Hero
                slides={slidesData}
                interval={6000}
                height="260px"
                borderRadius="20px"
                margin="60px"
            />
        </section>
    );
};

export default OnlineClassesPage;
